<template>
  <section v-if="order.isCommonCarrier">
    <a href="#" @click.prevent="open = true" :id="'commonCarrierTracker'+order.id">{{ linkText }}</a>
    <popover
      title="Add tracking number"
      :target="'#commonCarrierTracker'+order.id"
      v-model="open"
      placement="top"
    >
      <template slot="popover">
        <div>
          <label>Carrier:</label>
          <select v-model="carrier">
            <option
              v-for="carrier in carriers"
              :value="carrier.value"
              :key="carrier.value"
            >{{ carrier.text }}</option>
          </select>
        </div>
        <div>
          <label>Code:</label>
          <input v-model="code" />
        </div>
        <div style="margin-top: 6px;">
          <div v-if="error" style="margin-top: 6px;" class="error">{{ error }}</div>
          <btn
            type="primary"
            size="xs"
            @click.prevent="addTracking"
            :disabled="loading"
          >{{ buttonText }}</btn>
          <btn size="xs" @click.prevent="open = false">Cancel</btn>
        </div>
      </template>
    </popover>
  </section>
</template>

<script>
import gql from 'graphql-tag';
import Vue from 'vue';
import { createCommonCarrierTracker, downloadShippingLabelsUrl } from '../api.js';

export default {
  props: ['order'],
  data() {
    return {
      // value must be the subclass name of Sidekick::CommonCarrierTracker,
      // NOT the subclasses' carrier_name
      // e.g. Sidekick::CommonCarrierTracker::Fedex, NOT FedEx (caseing is important for rails' STI)
      carriers: [
        {
          value: 'Fedex',
          text: 'FedEx'
        },
        {
          value: 'GSO',
          text: 'GSO'
        }
      ],
      carrier: 'Fedex',
      code: '',
      open: false,
      loading: false,
      error: null,
    };
  },
  methods: {
    async addTracking() {
      this.loading = true;
      this.error = null;
      let { success, message, data } = await createCommonCarrierTracker(
        this.order,
        this.carrier,
        this.code
      );
      this.loading = false;
      if (!success) {
        this.error = message;
      } else {
        this.$notify({
          type: 'success',
          placement: 'bottom-right',
          title: `${this.carrier} tracking #${this.code} added!`,
          content: "See order page for detailed tracking info",
          icon: '',
        })
        this.open = false;
        this.code = '';
      }
    }
  },
  computed: {

    linkText() {
      return `Add tracking`
    },
    buttonText() {
      if (this.loading) {
        return 'Saving...';
      }
      return this.linkText;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CommonCarrierTracker.vue